<div class="success-container">
  <div class="success-card">
    <h1 class="succes-h1">Bedankt voor uw aankoop!</h1>
    <p>Uw product is verzonden naar: <strong>{{ email }}</strong></p>
    <p class="spam-warning">Controleer ook uw spam-map als u de e-mail niet ziet.</p>
    <button class="primary-button" (click)="redirectHome()">Ga terug naar Home</button>
  </div>
</div>
